import React, { useEffect, useState } from 'react';
import { Menu, X, BrainIcon } from 'lucide-react';
import { SparkleDecoration } from './ui/SparkleDecoration';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'El problema',
    href: '#el-problema'
  }, {
    name: 'Qué Incluye',
    href: '#el-pack'
  }, {
    name: 'Beneficios',
    href: '#bonos'
  }, {
    name: 'Testimonios',
    href: '#testimonios'
  }, {
    name: 'FAQ',
    href: '#faq'
  }];
  return <nav className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-cream/95 backdrop-blur-md shadow-sm py-3' : 'bg-cream py-5'}`} data-id="element-138">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-139">
        <div className="flex justify-between items-center" data-id="element-140">
          {/* Logo */}
          <div className="flex items-center gap-2" data-id="element-141">
            <span className="text-coral font-serif text-xl font-bold flex items-center gap-1" data-id="element-142">
              <SparkleDecoration size={16} color="#E8735A" type="star" data-id="element-143" />∞
              InfinitaMenteDigital
              <BrainIcon size={18} className="inline ml-0.5" data-id="element-144" />
            </span>
          </div>

          {/* Desktop Nav */}
          <div className="hidden md:flex items-center space-x-8" data-id="element-145">
            {navLinks.map(link => <a key={link.name} href={link.href} className="text-charcoal hover:text-coral font-medium transition-colors" data-id="element-146">
                {link.name}
              </a>)}
          </div>

          {/* CTA Button */}
          <div className="hidden md:block" data-id="element-147">
            <a href="#precio" className="bg-emerald-500 text-white px-6 py-2.5 rounded-full font-bold hover:scale-105 transition-transform duration-300 shadow-soft inline-block" data-id="element-148">
              Quiero mi Pack
            </a>
          </div>

          {/* Mobile Menu Button */}
          <div className="md:hidden flex items-center" data-id="element-149">
            <button onClick={() => setMobileMenuOpen(!mobileMenuOpen)} className="text-charcoal hover:text-coral transition-colors" data-id="element-150">
              {mobileMenuOpen ? <X size={28} data-id="element-151" /> : <Menu size={28} data-id="element-152" />}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Menu */}
      {mobileMenuOpen && <div className="md:hidden bg-cream border-t border-rose/20 absolute w-full shadow-lg" data-id="element-153">
          <div className="px-4 pt-2 pb-6 space-y-1 flex flex-col" data-id="element-154">
            {navLinks.map(link => <a key={link.name} href={link.href} onClick={() => setMobileMenuOpen(false)} className="block px-3 py-4 text-charcoal hover:bg-rose/10 hover:text-coral font-medium rounded-xl transition-colors" data-id="element-155">
                {link.name}
              </a>)}
            <a href="#precio" onClick={() => setMobileMenuOpen(false)} className="bg-emerald-500 text-white px-6 py-3 rounded-full font-bold text-center mt-4 shadow-soft" data-id="element-156">
              Acceder al Mega Pack
            </a>
          </div>
        </div>}
      {/* ¡Atención Mamás! band */}
      <div className="bg-burgundy text-white py-1 px-4 overflow-hidden" data-id="element-157">
        <div className="flex animate-marquee whitespace-nowrap" data-id="element-158">
          {[...Array(3)].map((_, i) => <span key={i} className="flex items-center gap-3 text-xs font-medium mx-8" data-id="element-159">
              <span data-id="element-160">📣</span>
              <span className="font-bold" data-id="element-161">¡Atención Mamás!</span>
              <span data-id="element-162">—</span>
              <span className="text-white/90" data-id="element-163">Oferta por tiempo limitado</span>
              <span data-id="element-164">✨</span>
              <span className="text-white/60" data-id="element-165">•</span>
              <span className="text-white/90" data-id="element-166">50% OFF solo hoy</span>
              <span data-id="element-167">🔥</span>
            </span>)}
        </div>
      </div>
    </nav>;
}